export default __webpack_public_path__ + "static/media/ruby.411dad54.svg";